// src/features/articles/components/RecommendedArticleListWide.js
import React from "react";
import { Link } from "react-router-dom";

import "../../../shared/styles/RecommendedArticleListWide.css"

import { BsEye, BsClock } from "react-icons/bs";

function formatThaiShortDate(ts) {
  if (!ts) return "";
  let date = ts;

  // รองรับ Timestamp ของ Firestore
  if (typeof ts.toDate === "function") date = ts.toDate();

  if (!(date instanceof Date)) return "";

  return date.toLocaleDateString("th-TH", {
    day: "numeric",
    month: "short",
  });
}

export default function RecommendedArticleListWide({ articles = [] }) {
  if (!articles.length) return null;

  return (
    <div className="article-recommended-wide">
      {/* <h2 className="article-recommended-title">
        บทความที่คุณอาจสนใจ
      </h2> */}

      {/* ใช้ Bootstrap grid: xs = 1 คอลัมน์, md ขึ้นไป = 2 คอลัมน์ */}
      <div className="row g-3">
        {articles.map((item) => (
          <div key={item.id} className="col-12 col-md-6">
            <Link
              to={`/articles/${item.slug}`}
              className="recommended-item"
            >

              {/* ด้านขวา: รูปปกเล็ก */}
              {item.cover && (
                <div className="recommended-thumb-wrapper">
                  <img
                    src={item.cover}
                    alt={item.title}
                    className="recommended-thumb"
                  />
                </div>
              )}


              {/* ด้านซ้าย: ข้อความ */}
              <div className="recommended-main">
                {/* บรรทัดบนสุด – category / subCategory */}
                <div className="recommended-meta-top">
                  {item.category?.name && (
                    <span className="recommended-category">
                      {item.category.name}
                    </span>
                  )}
                  {item.level && (
                    <span className="recommended-level">
                      {item.level === "general"
                        ? "General"
                        : item.level === "beginner"
                        ? "Beginner"
                        : item.level === "intermediate"
                        ? "Intermediate"
                        : item.level === "advanced"
                        ? "Advanced"
                        : item.level}
                    </span>
                  )}
                </div>

                {/* title */}
                <h3 className="recommended-title-wide">
                  {item.title}
                </h3>
                
                {item.subtitle && item.subtitle.trim() !== "" && (
                  <p className="recommended-subtitle">
                    {item.subtitle}
                  </p>
                )}

                {/* บรรทัดล่าง – วันที่ / เวลาอ่าน / จำนวนวิว */}
                <div className="recommended-meta-bottom">
                  {item.createdAt && (
                    <span>{formatThaiShortDate(item.createdAt)}</span>
                  )}

                  {typeof item.readTime === "number" && (
                    <>
                      <span>·</span>
                      <span>
                        {/* <BsClock size={12} />{" "} */}
                        {item.readTime} min read
                      </span>
                    </>
                  )}

                  {typeof item.views === "number" && (
                    <>
                      <span>·</span>
                      <span>
                        {/* <BsEye size={12} />{" "} */}
                        {item.views.toLocaleString()} views
                      </span>
                    </>
                  )}
                </div>
              </div>

              
            </Link>
          </div>
        ))}
      </div>
    </div>
  );
}
